const moment = require('moment');

export default function formatDate(value: any, formatString: string) {
    return value ? moment(value).format(formatString ? formatString : 'DD-MM-YYYY hh:mm:ss') : '';
}
